import { connect } from 'react-redux';

import LogForm from './LogForm.js';
// import { redux as apiRedux } from '../api';

const mapStateToProps = state => {
  return {
    user: state.api.user,
  };
};

const mapDispatchToProps = dispatch => {
  return {};
};

const ConnectedLogForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(LogForm);

export default ConnectedLogForm;
